import * as React from "react";
import {option} from "ts-option";
import {api} from "../../api/api";
import Modal from "../ui/modal/Modal";
import SingleFileSelector from "../file/SingleFileSelector";
import {ImportResult} from "../../model/importResult/ImportResult";
import Toast from "../helper/Toast";

interface IComponentProps {
	/**
	 * On modal close.
	 */
	onClose: () => void;
}

interface IState {
	/**
	 * Indicates if files are uploading
	 */
	filesUploading: boolean;
	/**
	 * Upload errors to display
	 */
	errors: string[];
}

type Props = IComponentProps

export default class UploadPartsModal extends React.Component<Props, IState> {

	constructor(props: Props) {
		super(props);
		this.state = {filesUploading: false, errors: []};
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={"Upload Graham parts"}>
				<SingleFileSelector onUpload={this.uploadFile}
									onCancel={this.props.onClose}
									errors={option(this.state.errors)}
									filesUploading={this.state.filesUploading}/>
			</Modal>
		);
	}

	uploadFile = (file: File) => {
		if (file) {
			this.setState({filesUploading: true}, () => {
					api.instance.partsApi.uploadGrahamParts(file).then(() => {
						Toast.success("Graham parts uploaded successfully.", "Parts upload");
						this.setState({filesUploading: false});
						this.props.onClose();
					}).catch(error => {
						const errors: string[] = []
						if (error.response) {
							errors.concat(ImportResult.fromJson(error.response.data).error)
						}
						this.setState({errors: errors, filesUploading: false});
						Toast.error("Cannot upload Graham parts.", "Parts upload");
					});
				}
			);
		}
	}
}

